import React from "react";
import { STORAGE_URL } from "constants";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { TextDirection } from "@react-pdf-viewer/core";
import { useLanguage } from "hooks";
import ar_AE from "@react-pdf-viewer/locales/lib/ar_AE.json";

const PDF_MODAL = ({ document }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";

  return (
    <div id="pdf_page" key={language.direction} className="h-100">
      {language.direction === "rtl" ? (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.0.279/build/pdf.worker.min.js">
          <Viewer
            fileUrl={`${STORAGE_URL}${document?.link}`}
            plugins={[defaultLayoutPluginInstance]}
            theme={{
              direction: TextDirection.RightToLeft,
            }}
            localization={ar_AE}
          />
        </Worker>
      ) : (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.0.279/build/pdf.worker.min.js">
          <Viewer
            fileUrl={`${STORAGE_URL}${document?.link}`}
            plugins={[defaultLayoutPluginInstance]}
          />
        </Worker>
      )}
    </div>
  );
};
export default PDF_MODAL;
